import React from 'react'

function ActiveCell(row) {
  return (
    <div>{row?.isActive ? 'Active' : 'not Active' }</div>
  )
}

export default ActiveCell